export default {
  getOrderMac: {
    method: 'get',
    url: 'order-mac/list',
    permission: {
      name: "获取MAC订单列表",
      page: "macOrder",
    }
  },
  addOrderMac: {
    method: 'post',
    url: 'order-mac/add',
    permission: {
      name: "添加MAC订单",
      page: "macOrder",
    }
  },
  deleteOrderMac: {
    method: 'post',
    url: 'order-mac/del',
    permission: {
      name: "删除MAC订单",
      page: "macOrder",
    }
  },
  downloadOrderMac: {
    method: 'post',
    url: 'order-mac/download',
    permission: {
      name: "下载MAC订单",
      page: "macOrder",
    }
  },
  createSequence: {
    method: 'get',
    url: 'company/sequence',
    permission: {
      name: "获取MAC订单流水号",
      page: "macOrder",
    }
  },
  getMacPool: {
    method: 'get',
    url: 'mac-pool/list',
    permission: {
      name: "获取MAC池列表",
      page: "macPool",
    }
  },
}
